<template>
  <div id="unlicensed">
    <div class="wrapper">
      <div class="block-info">
        <div class="logo">
          <icon-new-logo />
          <span class="name-app">Aneto´s Earned Value Management for Jira</span>
        </div>
        <div class="hi-name">
          The subscription to this Jira App <br />
          does not seem valid
        </div>
        <div class="message">
          Please go to the Apps -> Manage your Apps section and open the Aneto´s
          Earned Value Management for Jira app to renew the license
        </div>
        <div class="text">
          If you have any issues, please contact
          <a href="mailto: support@aneto.io">support@aneto.io</a>
        </div>
      </div>
      <div class="wrapper-img">
        <img-update-license />
      </div>
    </div>
  </div>
</template>

<script>
import ImgUpdateLicense from "./components/icons/updateLicense";
import IconNewLogo from "./components/icons/newLogo";
export default {
  name: "Unlicensed",
  components: {
    imgUpdateLicense: ImgUpdateLicense,
    iconNewLogo: IconNewLogo,
  },
  data() {
    return {
      userName: "my Dear Friend",
    };
  },
};
</script>

<style lang="scss">
#unlicensed {
  padding: 30px;
  .wrapper {
    max-width: 1377px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 40px 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(247, 248, 255, 0.9);
    backdrop-filter: blur(25px);
    border-radius: 10px;
    @media (max-width: 1280px) {
      padding: 40px;
    }
    @media (max-width: 1024px) {
      padding: 20px;
      flex-direction: column;
      justify-content: center;
    }
    .block-info {
      max-width: 570px;
      width: 100%;
      .logo {
        display: flex;
        align-items: center;
        margin-bottom: 35px;
        @media (max-width: 1024px) {
          justify-content: center;
        }
        svg,
        img {
          margin-right: 20px;
          max-width: 84px;
          width: 100%;
        }
        .name-app {
          font-weight: 500;
          font-size: 35px;
          line-height: 38px;
        }
      }
      .hi-name {
        font-style: normal;
        font-weight: 300;
        font-size: 28px;
        line-height: 30px;
        @media (max-width: 1024px) {
          text-align: center;
        }
      }
      .message {
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 28px;
        margin-top: 25px;
        margin-bottom: 35px;
        @media (max-width: 1024px) {
          text-align: center;
          & + .text {
            text-align: center;
            margin-bottom: 50px;
          }
        }
      }
    }
    .wrapper-img {
      @media (max-width: 1024px) {
        svg {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
